import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';

import { ShipmentNomination } from '../../models/nomination/shipment.nomination';
import { ShipmentConsolidation } from '../../shipment.service';

export type ShipmentPeopleCommand =
    | { type: 'add-watcher' }
    | { type: 'send-email'; email?: string }
    | { type: 'call'; phoneNumber?: string };

/** Read-only shipment contacts and watcher workspace. The shell owns all contact mutations. */
@Component({
    selector: 'app-shipment-people-panel',
    standalone: true,
    templateUrl: './shipment-people-panel.component.html',
    styleUrls: ['./shipment-people-panel.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, RouterModule, AvatarModule, ButtonModule, TagModule, TooltipModule]
})
export class ShipmentPeoplePanelComponent {
    readonly nominations = input<ShipmentNomination[]>([]);
    readonly consolidationEnabled = input(false);
    readonly consolidation = input<ShipmentConsolidation>();
    readonly consolidationLoading = input(false);
    readonly consolidationError = input(false);
    readonly retryConsolidation = output<void>();
    readonly canManageWatchers = input(false);
    readonly canNotify = input(false);
    readonly command = output<ShipmentPeopleCommand>();

    unavailableEmail(email?: string): boolean {
        return !email || email.includes('@abcxyz.com');
    }
}
